import React, { useEffect, useState } from "react";

import { Button, Offcanvas } from "react-bootstrap";

import { isLargeScreen } from "@/utils/Toolbox";

import useContactContext from "../../hooks/useContactContext";
import i18n from "../../i18n";
import ConfirmComponent from "../Confirm.component";
import { trackEvent } from "../GA.component";
import ContactCategoryList from "./ContactCategory.component";
import ContactForms from "./ContactForms.component";

interface ContactModalComponentProps {
  btnClass?: string;
  btnVariant?: string;
  btnLabel?: string;
}

const ContactModalComponent = ({
  btnClass = "p-1 ps-5 pe-5",
  btnVariant = "primary",
  btnLabel,
}: ContactModalComponentProps): React.JSX.Element | null => {
  const {
    openSection,
    setOpenSection,
    showConfirmModal,
    setShowConfirmModal,
    hasError,
    setCategory,
    submitted,
    category,
    cleanup,
  } = useContactContext();
  const { t } = i18n;
  const ctaLabel = btnLabel ?? t("Contact Us");
  const [placement, setPlacement] = useState<"bottom" | "end">("end");
  useEffect(() => {
    const handleResize = () => {
      setPlacement(isLargeScreen() ? "end" : "bottom");
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClose = () => {
    if (hasError || submitted || !category) {
      setOpenSection(false);
      cleanup();
    } else {
      setShowConfirmModal(true);
    }
  };

  return (
    <React.Fragment>
      <Button
        className={btnClass}
        variant={btnVariant}
        onClick={() => {
          setOpenSection(true);
          trackEvent("contact_us_open_modal");
        }}
      >
        {ctaLabel}
      </Button>

      <ConfirmComponent
        closeLabel={t("Keep Editing")}
        confirmLabel={t("Exit")}
        onConfirm={() => setShowConfirmModal(false)}
        onHide={() => setShowConfirmModal(false)} // same as confirm!
        show={showConfirmModal}
        bodyNode={
          <p className="text-center p-1 ps-5 pe-5">
            {t(
              "Looks like you haven’t finished your message. Do you want to keep editing or exit?",
            )}
          </p>
        }
        onClose={() => {
          setOpenSection(false);
          setShowConfirmModal(false);
          setCategory(undefined);
        }}
      />

      <Offcanvas
        scroll
        backdrop="static"
        className="contact-modal"
        onHide={handleClose}
        placement={placement}
        show={openSection}
      >
        <Offcanvas.Header />
        <Offcanvas.Body>
          {openSection ? (
            <React.Fragment>
              <Button
                className="d-flex justify-content-center ms-auto contact-modal-close-btn"
                onClick={handleClose}
              >
                &times;
              </Button>

              <ContactCategoryList />
              <ContactForms />
            </React.Fragment>
          ) : null}
        </Offcanvas.Body>
      </Offcanvas>
    </React.Fragment>
  );
};

export default ContactModalComponent;
